<template>
  <div>
    <div class="simple-player-con">
      <img v-show="loading" src="@/assets/images/free-practice/loading.svg" class="loading-icon" />
      <img
        v-show="!loading && playing"
        src="@/assets/images/free-practice/pause-audio.svg"
        class="pause-icon"
      />
      <img
        v-show="!loading && !playing"
        src="@/assets/images/free-practice/play.svg"
        class="play-icon"
      />
      <svg v-show="!loading" viewBox="22 22 44 44" class="prograss-con">
        <circle
          :id="id"
          cx="44"
          cy="44"
          :r="progressR"
          fill="none"
          stroke="#fff"
          stroke-width="3.6"
        ></circle>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    playing: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    percent: {
      type: String || Number,
      default: '0.0',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    percent: {
      handler() {
        this.setProgress(this.percent)
      },
      immediate: true,
    },
  },

  data() {
    return {
      progressR: 19.5,
    }
  },
  methods: {
    setProgress(percent) {
      // console.log(percent)
      let dom = document.getElementById(this.id)
      const perimeter = 2 * Math.PI * this.progressR
      const offset = perimeter - (percent / 100) * perimeter
      if (dom) {
        dom.style.strokeDasharray = perimeter
        dom.style.strokeDashoffset = offset
        // console.log(perimeter, 'perimeter')
        // console.log(offset, 'offset')
      }
    },
  },
  mounted() {
    this.setProgress(0)
  },
}
</script>
<style lang="scss" scoped>
.simple-player-con {
  cursor: pointer;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background: #5f9595;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  position: relative;
  color: #fff;
  .loading-icon {
    width: 24px;
    height: 24px;
    animation-name: spin;
    animation-duration: 1000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  .pause-icon {
    width: 24px;
    height: 24px;
  }
  .play-icon {
    width: 9px;
    margin-left: 3px;
  }
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
.simple-player-con::after {
  content: '';
  position: absolute;
  top: 0;
  width: 0;
  background: transparent;
  width: 32px;
  height: 32px;
}
.prograss-con {
  width: 30px;
  height: 30px;
  position: absolute;
  transform: rotate(-90deg);
}
</style>
